module.exports = __webpack_public_path__ + "static/media/reward_activities.827692ce.png";